"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxTreeList = exports.bfsSearch = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var TreeView_1 = tslib_1.__importDefault(require("@material-ui/lab/TreeView"));
var ExpandMore_1 = tslib_1.__importDefault(require("@material-ui/icons/ExpandMore"));
var ChevronRight_1 = tslib_1.__importDefault(require("@material-ui/icons/ChevronRight"));
var TreeItem_1 = tslib_1.__importDefault(require("@material-ui/lab/TreeItem"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/fp/isEqual"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
var react_highlight_words_1 = tslib_1.__importDefault(require("react-highlight-words"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var core_1 = require("@material-ui/core");
var CheckboxListItem_1 = require("../../ComplexComponents/ColumnGroupPicker/CheckboxListItem");
exports.bfsSearch = function (graph, targetId) {
    var queue = tslib_1.__spreadArrays(graph);
    while (queue.length > 0) {
        var currNode = queue.shift();
        if (currNode.id === targetId) {
            return currNode;
        }
        if (currNode.children) {
            queue.push.apply(queue, currNode.children);
        }
    }
    return [];
};
exports.CheckboxTreeList = function (_a) {
    var nodeData = _a.nodeData, expandDefault = _a.expandDefault, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.searchText, searchText = _c === void 0 ? '' : _c, selectedNodeIds = _a.selectedNodeIds, setSelectedNodeIds = _a.setSelectedNodeIds;
    var isHighlighting = !!searchText && searchText.length > 1;
    var getAllIds = react_1.useCallback(function (node, idList) {
        if (idList === void 0) { idList = []; }
        var _a = node, id = _a.id, children = _a.children;
        idList.push(id);
        if (children) {
            children.forEach(function (child) { return getAllIds(child, idList); });
        }
        return idList;
    }, []);
    var getAllChild = react_1.useCallback(function (id) {
        return getAllIds(exports.bfsSearch(nodeData, id));
    }, [getAllIds, nodeData]);
    var AllChildrenValues = react_1.useCallback(function (allData) {
        return allData
            .filter(function (row) { return !row.selectAll; })
            .map(function (row) { return row.id; })
            .flatMap(function (currentValue) { return getAllChild(currentValue); });
    }, [getAllChild]);
    var allNodeRelatedIds = react_1.useCallback(function (id) {
        return getAllChild(id);
    }, [getAllChild]);
    var getSelectionType = react_1.useCallback(function (id, selectAll) {
        if (selectAll) {
            var totalLength = AllChildrenValues(nodeData).length;
            var selectedLength = selectedNodeIds.length;
            var isChecked_1 = selectedLength === totalLength;
            var isIntermediate_1 = selectedLength > 0 && selectedLength < totalLength && !isChecked_1;
            return {
                isIntermediate: isIntermediate_1,
                isChecked: isChecked_1,
            };
        }
        var relatedIds = allNodeRelatedIds(id).map(function (nodeId) { return selectedNodeIds.indexOf(nodeId) > -1; });
        var isIntermediate = relatedIds.some(function (item) { return item === true; });
        var isChecked = relatedIds.every(function (item) { return item === true; });
        return {
            isIntermediate: isIntermediate && !isChecked,
            isChecked: isChecked,
        };
    }, [AllChildrenValues, allNodeRelatedIds, nodeData, selectedNodeIds]);
    var getAllFathers = function (id, list) {
        if (list === void 0) { list = []; }
        var node = exports.bfsSearch(nodeData, id);
        var parent = get_1.default('parent', node);
        if (parent) {
            list.push(parent);
            return getAllFathers(parent, list);
        }
        return list;
    };
    var isAllChildrenChecked = react_1.useCallback(function (node, list) {
        var id = node.id;
        var allChild = getAllChild(id);
        var nodeIdIndex = allChild.indexOf(id);
        allChild.splice(nodeIdIndex, 1);
        return allChild.every(function (nodeId) {
            return selectedNodeIds.concat(list).includes(nodeId);
        });
    }, [getAllChild, selectedNodeIds]);
    var handleNodeSelect = function (event, nodeId, selectAll) {
        event.stopPropagation();
        var allChild = getAllChild(nodeId);
        var fathers = getAllFathers(nodeId);
        if (selectAll) {
            if (isEqual_1.default(selectedNodeIds.length, AllChildrenValues(nodeData).length)) {
                setSelectedNodeIds([]);
            }
            else {
                setSelectedNodeIds(AllChildrenValues(nodeData));
            }
        }
        else if (selectedNodeIds.includes(nodeId)) {
            setSelectedNodeIds(function (prevSelectedNodes) {
                return prevSelectedNodes.filter(function (id) { return !allChild.concat(fathers).includes(id); });
            });
        }
        else {
            var ToBeChecked_1 = allChild;
            for (var i = 0; i < fathers.length; ++i) {
                if (isAllChildrenChecked(exports.bfsSearch(nodeData, fathers[i]), ToBeChecked_1)) {
                    ToBeChecked_1.push(fathers[i]);
                }
            }
            setSelectedNodeIds(function (prevSelectedNodes) {
                return tslib_1.__spreadArrays(prevSelectedNodes).concat(ToBeChecked_1);
            });
        }
    };
    var handleExpandClick = react_1.useCallback(function (event) {
        return event.stopPropagation();
    }, []);
    var TreeItem = core_1.withStyles({
        root: {
            '&.root': {
                padding: 0,
            },
            '&.root > .content': {
                background: 'transparent',
            },
            '&.root > .content > .label': {
                background: 'transparent',
            },
            '&.root.selected > .content > .label': {
                background: 'transparent',
            },
            '&.root > .content > .iconContainer': {
                background: function (props) {
                    return !isEmpty_1.default(props.children) ? 'initial' : 'none';
                },
            },
        },
    })(TreeItem_1.default);
    var TextLabel = function (nodes) {
        var children = nodes.children, name = nodes.name;
        if (isHighlighting) {
            return (react_1.default.createElement(react_highlight_words_1.default, { autoEscape: true, searchWords: [searchText], className: children ? 'grouped_option_bold' : '', textToHighlight: name, highlightClassName: "option_highlighted_text" }));
        }
        if (children)
            return react_1.default.createElement("span", { className: "grouped_option_bold" }, name);
        return name;
    };
    var renderTree = function (nodes) {
        var id = nodes.id, selectAll = nodes.selectAll;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TreeItem, { nodeId: id, classes: {
                    root: 'root',
                    content: 'content',
                    selected: 'selected',
                    label: 'label',
                    iconContainer: 'iconContainer',
                }, onClick: handleExpandClick, onLabelClick: handleExpandClick, label: react_1.default.createElement(CheckboxListItem_1.CheckboxListItem, { testId: "list-item-checkbox-" + id, checked: getSelectionType(id, selectAll).isChecked, indeterminate: getSelectionType(id, selectAll).isIntermediate, onChange: function (event) { return handleNodeSelect(event, nodes.id, selectAll); }, disabled: disabled, label: TextLabel(nodes) }) }, Array.isArray(nodes.children)
                ? nodes.children.map(function (node) { return (react_1.default.createElement(react_1.Fragment, { key: node.id }, renderTree(node))); })
                : null)));
    };
    return (react_1.default.createElement(TreeView_1.default, { defaultCollapseIcon: react_1.default.createElement(ExpandMore_1.default, null), defaultExpandIcon: react_1.default.createElement(ChevronRight_1.default, null), defaultExpanded: expandDefault ? AllChildrenValues(nodeData) : [], selected: selectedNodeIds, multiSelect: true }, nodeData.map(function (node) { return (react_1.default.createElement(react_1.Fragment, { key: node.id }, renderTree(node))); })));
};
